import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { RouteNames } from '@/router/routeNames';
import { unsupportedBrowser } from '@/shared/util/helpers';
import { useGlobalStore } from '@/stores/global/global.store';
import type { NavigationGuardWithThis, RouteLocationNormalized } from 'vue-router';

export const preloginNavGuard: NavigationGuardWithThis<undefined> = async (
  to: RouteLocationNormalized
) => {
  const globalStore = useGlobalStore();
  try {
    const srcId = to.query.source ?? window.localStorage.getItem('sourceId');
    if (srcId) {
      const sourceIdStr = Array.isArray(srcId) ? srcId.join(',') : String(srcId);
      window.localStorage.setItem('sourceId', sourceIdStr); // set sourceId
    }
  } catch (_error) {
    /* empty */
  }

  // TODO: handle when user is logged in already
  if (to.name === RouteNames.PRE_LOGIN) {
    await globalStore.getAppInfo();
  }
  if (
    CapacitorFacade.isNativePlatform() &&
    (globalStore.isOptionalUpdateAvailable || globalStore.isCriticalUpdateAvailable)
  ) {
    return to.name === RouteNames.APP_UPDATE ? true : { name: RouteNames.APP_UPDATE };
  } else if (CapacitorFacade.isWeb() && unsupportedBrowser()) {
    return to.name === RouteNames.UNSUPPORTED_BROWSER
      ? true
      : { name: RouteNames.UNSUPPORTED_BROWSER };
  } else if (globalStore.isMaintenanceMode) {
    return to.name === RouteNames.MAINTENANCE_MODE ? true : { name: RouteNames.MAINTENANCE_MODE };
  } else {
    return { name: RouteNames.DASHBOARD };
  }
};
